import { makeStyles, Theme } from '@material-ui/core/styles';

const FOORBAN_ORANGE = 'rgb(232, 84, 21)';

export const useOpenAppDialogStyles = makeStyles((theme: Theme) => ({
	paper: {
		borderRadius: 20,
		overflow: 'hidden',
		maxWidth: 400,
		margin: theme.spacing(2),
	},
	header: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 120,
		background: `linear-gradient(135deg, ${FOORBAN_ORANGE} 0%, #f39c3d 100%)`,
		color: theme.palette.common.white,
	},
	image: {
		display: 'block',
		width: '100%',
		maxHeight: 220,
		objectFit: 'cover',
	},
	headerIcon: {
		fontSize: 64,
	},
	closeButton: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(1),
		color: theme.palette.common.white,
		backgroundColor: 'rgba(0, 0, 0, 0.25)',
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.4)',
		},
	},
	body: {
		padding: theme.spacing(3, 3, 1),
		textAlign: 'center',
	},
	title: {
		fontWeight: 700,
		color: theme.palette.primary.main,
		marginBottom: theme.spacing(1),
	},
	content: {
		whiteSpace: 'pre-line',
		color: theme.palette.text.secondary,
	},
	actions: {
		display: 'flex',
		flexDirection: 'column',
		gap: `${theme.spacing(1)}px`,
		padding: theme.spacing(2, 3, 3),
	},
	cta: {
		borderRadius: 999,
		padding: theme.spacing(1.5),
		fontWeight: 700,
		textTransform: 'none',
		fontSize: '1rem',
		backgroundColor: FOORBAN_ORANGE,
		color: theme.palette.common.white,
		'&:hover': {
			backgroundColor: '#c94710',
		},
	},
	dismiss: {
		textTransform: 'none',
		color: theme.palette.text.secondary,
	},
}));
